export default "__VITE_ASSET__Ba3sXX_O__"